export const environment = {
  name: 'staging',
  production: false,
  apiBaseUrl: 'https://stg.pmapi.wealthmax.co.uk/api',
  notificationHubBaseUrl: 'https://stg.pmapi.wealthmax.co.uk',
  swaggerUrl: 'https://stg.pmapi.wealthmax.co.uk/swagger'
};
